import React from 'react';
import { useGPS } from '../../contexts/GPSContext';
import { useGPSStats } from '../../hooks/useGPSStats';
import GPSSectorsStats from './GPSSectorsStats';

const GPSSecteurs = () => {
  const gps = useGPS();
  const stats = useGPSStats();

  return (
    <div className="space-y-6">
      <GPSSectorsStats stats={stats} issues={gps.issues} />
    </div>
  );
};

export default GPSSecteurs;
